module.exports = __webpack_public_path__ + "img/Führungskraft.5c202156.svg";